module.exports = __webpack_public_path__ + "img/solucion-colaboracion.620e47d9.png";